<template>
  <div>
    <template v-if="!loading">
      <h1>{{ $lang("體能挑戰日") }}</h1>
      <div class="dashed">
        <div class="summer-attention" v-if="physicalChallenge.content">
          <div v-html="physicalChallenge.content"></div>
        </div>
        <div v-if="isEnroll || isGroup">
          <template v-if="isEnroll">
            <p>
              <span>{{ $lang("TEXT_VIEW_INFORMATION") }}</span>
            </p>
            <ul>
              <template v-for="item in records">
                <li v-if="item.status != 'draft'" :key="item.id">
                  <span></span>
                  <router-link
                    class="submitForm"
                    :to="`physical-challenge-game/perview/${item.id}`"
                    >{{ item.title }}</router-link
                  >
                </li>
                <li v-else :key="item.id">
                  <span>{{ item.title }}</span>
                  <router-link
                    class="btn btn-primary"
                    :to="`physical-challenge-game/edit/${item.id}`"
                    >{{ $lang("修改") }}</router-link
                  >
                  <b-btn variant="info" @click="handlerDelete(item.id)">{{
                    $lang("刪除")
                  }}</b-btn>
                  <!-- <b-btn variant="danger" @click="handlerSumbit(item.id)">{{$lang("提交")}}</b-btn> -->
                  <router-link
                    variant="info"
                    class="btn btn-danger"
                    :to="`physical-challenge-game/edit/${item.id}`"
                    >{{ $lang("提交") }}</router-link
                  >
                </li>
              </template>
            </ul>
          </template>
          <template v-if="isGroup">
            <p>
              <span>{{ $lang("TEXT_VIEW_INFORMATION") }}</span>
            </p>
            <ul>
              <template v-for="item in groups">
                <li v-if="item.status != 'draft'" :key="item.id">
                  <span></span>
                  <router-link
                    class="submitForm"
                    :to="`physical-challenge-game/perview/${item.id}`"
                    >{{ item.title }}</router-link
                  >
                </li>
                <li v-else :key="item.id">
                  <span>{{ item.title }}</span>
                  <router-link
                    class="btn btn-primary"
                    :to="`physical-challenge-game/edit/${item.id}`"
                    >{{ $lang("修改") }}</router-link
                  >
                  <b-btn variant="info" @click="handlerDelete(item.id)">{{
                    $lang("刪除")
                  }}</b-btn>
                  <!-- <b-btn variant="danger" @click="handlerSumbit(item.id)">{{$lang("提交")}}</b-btn> -->
                  <router-link
                    variant="info"
                    class="btn btn-danger"
                    :to="`physical-challenge-game/edit/${item.id}`"
                    >{{ $lang("提交") }}</router-link
                  >
                </li>
              </template>
            </ul>
          </template>
        </div>
        <div v-if="!isEnroll || !isGroup">
          <!-- <p>
                    <router-link to="physical-challenge-game" class="listen-tnc">{{$lang("TEXT_AGREE_CONTENT")}}</router-link>
                </p> -->
          <p v-if="!isEnroll">
            <span @click="openModel(1)" class="listen-tnc btn">{{
              $lang("TEXT_AGREE_CONTENT")
            }}</span>
          </p>
          <p v-if="!isGroup">
            <span @click="openModel(2)" class="listen-tnc btn">{{
              $lang("TEXT_TEAM_AGREE_CONTENT")
            }}</span>
          </p>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="spinner">
        <b-spinner variant="primary" label="Spinning"></b-spinner>
      </div>
    </template>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import game from "@/components/game";
import List from "@/components/List";
export default {
  components: {
    game,
    List,
  },
  data() {
    return {
      loading: true,
      isReadOnly: true,
      isAgree: false,
      records: [],
      groups: [],
      dynamicGame: {},
    };
  },
  watch: {
    popupMsg(n) {
      // console.log(n,"监听");
      if (n) {
        this.popup();
      }
    },
  },
  created() {
    this.isLoading();
    this.$store.dispatch("base/getPage");
  },
  methods: {
    popup() {
      var that = this;
      var timer = null;
      console.log(this.popupMsg, "pop");
      if (this.popupMsg) {
        newSwal();
      }
      function newSwal() {
        let html = "";
        for (let index = 0; index < that.popupMsg.child.length; index++) {
          html += `<div id='${that.popupMsg.child[index].slug}' style="display: none">${that.popupMsg.child[index].description}	</div>`;
        }

        // <div id="home-tab2" style="display: none">
        // 	  <p> ${that.popupMsg.child[0].description}</p>
        // 	</div>
        Swal.fire({
          title: that.popupMsg.title,
          html:
            `<div>
							<h1></h1>
							<div>
                ${that.popupMsg.description}
							</div>` +
            html +
            `</div>`,
          confirmButtonText: `<span id="count"><span> ${that.$lang(
            "我知道了"
          )}`,
          allowOutsideClick: false,
          showConfirmButton: true,
        });
        Swal.getConfirmButton().style.display = "none";
      }

      function countDown(s = 5) {
        clearInterval(timer);
        Swal.disableButtons();
        document.getElementById("count").innerHTML = `${that.$lang(
          "我知道了"
        )}（${s}）`;
        timer = setInterval(() => {
          s -= 1;
          document.getElementById("count").innerHTML = `${that.$lang(
            "我知道了"
          )}（${s}）`;
          if (s === 0) {
            clearInterval(timer);
            Swal.enableButtons();
            document.getElementById("count").innerHTML = `${that.$lang(
              "我知道了"
            )}`;
          }
        }, 1000);
      }

      process(({ node, attrName, attrValue }) => {
        node.addEventListener("click", () => {
          process(({ node, attrName, attrValue }) => {
            document.getElementById(attrValue).style.display = "none";
          });
          let display = document.getElementById(attrValue).style.display;
          if (display == "none") {
            countDown();
            document.getElementById(attrValue).style.display = "block";
            Swal.getConfirmButton().style.display = "block";
          }
          if (display == "block") {
            document.getElementById(attrValue).style.display = "none";
          }
        });
      });

      function process(cb) {
        let links = document.querySelectorAll(".link");
        links.forEach((node) => {
          Array.from(node.attributes).forEach((attr) => {
            const attrName = attr.name;
            const attrValue = attr.value;
            if (attrName === "data-target") {
              cb({
                node,
                attrName,
                attrValue,
              });
            }
          });
        });
      }
    },
    async isLoading() {
      this.loading = true;
      await this.getRecordList();
      await this.getGroupList();
      this.loading = false;
    },
    // 获取报名表记录
    async getRecordList() {
      const params = {
        groupType: "individual",
      };
      try {
        let resp = await $apis.dynamic.recordList(params);
        resp.code === 0 && (this.records = resp.data.records);
      } catch (e) {
        console.log(e);
      }
    },
    // 獲取團隊報名記錄
    async getGroupList() {
      const params = {
        groupType: "team",
      };
      try {
        let resp = await $apis.dynamic.recordList(params);
        resp.code === 0 && (this.groups = resp.data.records);
      } catch (e) {
        console.log(e);
      }
    },
    // 删除报名表记录
    async deleteRecordDetail(id) {
      try {
        let resp = await $apis.dynamic.deleteRecordDetail({
          id,
        });
        await this.getRecordList();
        await this.getGroupList();
        if (resp.code == 0) this.notification.success(this.$lang("删除成功"));
        else throw new Error(resp);
      } catch (e) {
        this.notification.error(this.$lang("删除失败"));
        console.log(e);
      }
    },
    // 正式提交表明表记录
    async formalSubmission(id) {
      try {
        let resp = await $apis.dynamic.formalSubmission({
          id,
        });
        await this.getRecordList();
        await this.getGroupList();
        if (resp.code == 0) this.notification.success(this.$lang("提交成功"));
        else throw new Error(resp);
      } catch (e) {
        this.notification.success(this.$lang("提交失败"));
        console.log(e);
      }
    },
    handlerDelete(id) {
      let r = confirm(this.$lang("是否刪除報名表!"));
      if (r == true) {
        this.deleteRecordDetail(id);
      }
    },
    handlerSumbit(id) {
      let r = confirm(this.$lang("是否確認提交!"));
      if (r == true) {
        this.formalSubmission(id);
      }
    },
    // 個人/團隊 同意報名
    openModel(val) {
      if (val === 2) {
        this.$router.push({
          path: "physical-challenge-game",
          query: { type: "team" },
        });
      } else {
        this.$router.push({
          path: "physical-challenge-game",
          query: { type: "individual" },
        });
      }
    },
  },
  computed: {
    popupMsg() {
      return this.$store.state.base.physicalChallengePopupMsg;
    },
    physicalChallenge() {
      return this.$store.state.base.physicalChallengeGuidelines;
    },
    isEnroll() {
      return this.records.length || 0;
    },
    isGroup() {
      return this.groups.length || 0;
    },
  },
};
</script>
